import styled, { css } from 'styled-components'

import {
  LinkPrimaryButton as BaseLinkPrimaryButton,
  LinkSecondaryButton as BaseLinkSecondaryButton,
} from '../../../../../global/LinkButton'

import CustomizeIconSvg from '../../../../../../img/rewards/customize-dispensary.inline.svg'
import StartEscriptIconSvg from '../../../../../../img/rewards/escript-protocol.inline.svg'
import StoreIcon from '../../../../../../img/rewards/store.inline.svg'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
  padding: 40px 0;
  align-items: flex-start;
  width: 100%;

  @media (min-width: 992px) {
    padding: 40px 0;
    align-content: center;
    gap: 32px;
    max-width: 760px;
    margin: 0 auto;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: center;
`

export const Icon = styled(StoreIcon)`
  width: 87.27px;
  height: 80px;
  fill: #144683;
  flex-shrink: 0;
`

export const Title = styled.h2`
  font-size: 22px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: bold;
`

export const Description = styled.p`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`

export const Actions = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;

  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

const iconsStyles = css`
  width: 16px;
  height: 16px;
  margin-right: 4px;
  vertical-align: bottom;
  stroke: currentColor;
  path {
    stroke: currentColor;
  }
`
export const CustomizeIcon = styled(CustomizeIconSvg)`
  ${iconsStyles};
`
export const StartEscriptIcon = styled(StartEscriptIconSvg)`
  ${iconsStyles};
`

const buttonStyles = css`
  font-size: 18px;
  padding: 16px 32px;
  border-radius: 12px;
  text-transform: none;
  gap: 8px;

  @media (max-width: 768px) {
    min-width: 136px;
    max-height: 56px;
    padding: 16px 32px;
    flex-grow: 1;
  }
`
export const LinkPrimaryButton = styled(BaseLinkPrimaryButton)`
  ${buttonStyles};
  background-color: #0e335f;

  &:hover {
    background-color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.background};
    color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.text};
  }
`

export const LinkSecondaryButton = styled(BaseLinkSecondaryButton)`
  ${buttonStyles};
  border: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.background};
    color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.text};
  }
`
